import styles from './PendingCoinCard.module.css';

export const rarityName = (rarity) => (rarity ? rarity.charAt(0).toUpperCase() + rarity.slice(1) : 'New');

/**
 * A coin that was earned but is held until the email is verified: the coin
 * with a lock, a slow shimmer while it waits, and a "verify to claim" label.
 * Once claimed it is an ordinary coin (CoinCelebration plays the reveal).
 */
export default function PendingCoinCard({ coin }) {
    if (!coin) return null;
    return (
        <div className={styles.card} data-testid="pending-coin-card" data-rarity={coin.rarity || undefined}>
            <div className={styles.coinWrap}>
                <div className={styles.coin}>
                    {coin.coinImageUrl
                        ? <img src={coin.coinImageUrl} alt="" className={styles.coinImage} />
                        : <span className={styles.coinEmoji} aria-hidden="true">🪙</span>}
                    <span className={styles.shimmer} aria-hidden="true" />
                </div>
                <span className={styles.lock} aria-hidden="true">🔒</span>
            </div>
            <div className={styles.text}>
                <p className={styles.status}>Pending · verify to claim</p>
                {coin.coinLabel && <p className={styles.name}>{coin.coinLabel}</p>}
                <p className={styles.rarity}>{rarityName(coin.rarity)} coin</p>
            </div>
        </div>
    );
}
